export const PO_STATUS_FILTERS = { po_number: "", cust_code: "", partner: "", status_850: "", status_997: "", reconciliation_status: "", status_856: "", status_810: "" };

const STATUS = {
  RECEIVED: ["Received", "green"], ACCEPTED: ["Accepted", "green"], MATCHED: ["Matched", "green"],
  DRAFT: ["Draft", "amber"], READY_TO_SEND: ["Ready to Send", "amber"], AWAITING_MDN: ["Awaiting MDN", "amber"],
  AWAITING_PO_DETAILS: ["Awaiting PO Details", "amber"], REVIEW_REQUIRED: ["Review Required", "amber"],
  PRESENT: ["Present", "amber"], UNKNOWN: ["Unknown", "amber"],
  MISMATCH: ["Mismatch", "red"], MISSING_IN_PO_DETAILS: ["Missing in PO Details", "red"],
  REJECTED: ["Rejected", "red"], IT_ATTENTION_REQUIRED: ["IT Attention Required", "red"],
  NOT_STARTED: ["Not Started", "gray"], NOT_RECEIVED: ["Not Received", "gray"], NOT_RETAINED: ["No Retained 850", "gray"], NOT_PRESENT: ["Not Present", "gray"], NOT_EVALUATED: ["Not Evaluated", "gray"], NOT_APPLICABLE: ["N/A", "gray"],
};

export const FIELD_LABELS = {
  WALMART_ITEM: "Walmart Item", VENDOR_PRODUCT: "Product Code", QUANTITY: "Quantity", UNIT_COST: "Unit Cost",
  MABD: "MABD", CREATE_DATE: "Create Date", DESTINATION_NODE: "Destination Node", SUPPLIER_NUMBER: "Supplier Number",
  LINE_MISSING: "Missing Line", LINE_EXTRA: "Extra Line",
};

export function statusInfo(status) { const [label, tone] = STATUS[status] || ["Unknown", "amber"]; return { label, tone }; }
export function buildPoStatusQuery(filters, page, pageSize, sortBy = "last_activity_at", sortDir = "desc") {
  const query = new URLSearchParams({ page: String(page), page_size: String(pageSize), sort_by: sortBy, sort_dir: sortDir });
  Object.entries(filters).forEach(([key, value]) => { if (String(value || "").trim()) query.set(key, String(value).trim()); });
  return query.toString();
}
export function formatTime(value) { return value ? new Date(value).toLocaleString() : "—"; }
export function formatOptionalTime(value) { return value ? new Date(value).toLocaleString() : "N/A"; }
export function formatDate(value) { return value || "N/A"; }
